///////////////////////////////////////////////////

import { ofType } from 'redux-observable';
import { EMPTY, merge, of } from 'rxjs';
import { debounceTime, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { liveInputFormActions } from 'state/secondaryMarket/live/form/input/inputForm.actions';
import type { EpicWithThunk } from 'state/state.common';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';

export function triggerAmendLiveTabContentPersistenceEpic(): EpicWithThunk {
  return (
    actions$,
    state$,
    {
      selectors: {
        fromSecondaryMarket: {
          live: {
            form: {
              input: { getAmendFormTabContentToPersist: getAmendLiveFormTabContentToPersist },
            },
          },
        },
      },
      scheduler,
    },
  ) => {
    const newForm$ = actions$.pipe(
      ofType('WORKSPACE_TAB_CREATED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketPostEvents' && tabType === 'live'),
      map(({ id }) => id),
    );
    const modifyForm$ = actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_FORM_FIELD_CHANGED'),
      debounceTime(3_000, scheduler),
      withLatestFrom(state$),
      filter(([{ tabId }, state]) => getWorkspaceType(state, tabId) === 'secondaryMarketPostEvents'),
      map(([{ tabId }, _]) => tabId),
    );
    return merge(modifyForm$, newForm$).pipe(
      withLatestFrom(state$),
      mergeMap(([tabId, state]) => {
        const persistedTabContent = getAmendLiveFormTabContentToPersist(state, tabId);
        if (persistedTabContent === undefined) {
          return EMPTY;
        }
        return of(
          liveInputFormActions.tabContentPersistenceRequested(tabId, 'secondaryMarketPostEvents', persistedTabContent),
        );
      }),
    );
  };
}
